import jwtDecode from "jwt-decode"
import humps from "humps"

const accessToken = useLocalStorage<string | null>(
  "access-token",
  null
)

type MerchantTokenClaims = {
  userId: string
  tenant: string
}

const tokenClaims = computed<MerchantTokenClaims | null>(
  () =>
    accessToken.value
      ? humps.camelizeKeys<MerchantTokenClaims>(
          jwtDecode(accessToken.value)
        )
      : null
)

const isLoggedIn = computed(() => !!tokenClaims.value)

const setToken = (value: string | null) => {
  accessToken.value = value
}

export const useAuth = () => ({
  accessToken,
  isLoggedIn,
  setToken,
})
